import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import { Container } from './components/Container';
import { AppProvider } from './Context';
import { App } from './Pages/App';
import { registerServiceWorker, unregisterServiceWorkers } from './serviceWorkerRegistration';

import 'bootstrap/dist/css/bootstrap.min.css'; 
import './index.scss';
import './theme/variables.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppProvider>
      <Container>
        <App />
      </Container>
    </AppProvider>
  </BrowserRouter>
);

reportWebVitals();

if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  unregisterServiceWorkers();
}
